import { atom } from "recoil"

export const teamMembersRequestIdState = atom<number>({
  key: "atoms/organization/teamMembersRequestIdState",
  default: 0,
})
